module.exports = __webpack_public_path__ + "img/720.e061d50c.svg";